import { types } from "../types/types";
const intitalState = {
    allServices: [],
    subServices: [],
    serviceDetails: null,
};

const servicesReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.SERVCIES:
            return {
                ...state,
                allServices: action.payload,
            };
        case types.SUB_SERVCIES:
            return {
                ...state,
                subServices: action.payload,
            };
        case types.SERVICE_DETAILS:
            return {
                ...state,
                serviceDetails: action.payload,
            };
        default:
            return { ...state };
    }
};

export default servicesReducer;
